import React, {useEffect, useRef} from 'react';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import './map.scss';

const Map = ({places, onSelectPlace}) => {

    const map = useRef(null);
    const markersLayer = useRef(null);

    useEffect(() => {
        if (map.current === null) {
            map.current = L.map('map', {
                zoomControl: false
            }).setView([52.407596082176234, 17.083787787345795], 5);

            L.control.zoom({
                position: 'bottomright'
            }).addTo(map.current);

            map.current.addLayer(L.tileLayer(
                'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                {
                    maxZoom: 18,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                }
            ));
        }
    }, []);

    useEffect(() => {

        const onMarkerClick = (e) => {
            onSelectPlace(e.target.options.place);
        }

        if (markersLayer.current !== null) {
            map.current.removeLayer(markersLayer.current);
            markersLayer.current = null;
        }

        markersLayer.current = L.markerClusterGroup({
            showCoverageOnHover: false,
            iconCreateFunction: function (cluster) {

                // get the number of items in the cluster
                const count = cluster.getChildCount();

                return L.divIcon({
                    html: `<div><span>${count}</span></div>`,
                    className: 'leaflet-marker-icon marker-cluster marker-cluster-large leaflet-zoom-animated leaflet-interactive fix-cluster',
                    iconSize: null
                });
            }
        });

        const markers = [];

        for (let place of places) {

            markers.push(L.marker([place.lat, place.lon]));
            const marker = L.marker([place.lat, place.lon], {place});
            marker.on('click', onMarkerClick);
            markersLayer.current.addLayer(marker);
        }

        map.current.addLayer(markersLayer.current);

        let group = new L.featureGroup(markers);

        if (window.innerWidth <= 767) {
            map.current.fitBounds(group.getBounds());
        } else {
            map.current.fitBounds(group.getBounds(), {paddingTopLeft: [230, 30]});
        }

        console.log(group.getBounds());

    }, [places]); // eslint-disable-line react-hooks/exhaustive-deps

    return <div id={'map'}/>;

}

export default Map;
